import React from 'react';
import { observer } from 'mobx-react';
import { classes } from '~utils/ClassNames';
import { ICartItem as ICartItemEntity } from '~domain/entities/CartItem/ICartItem';
import { useTranslation } from '~sharedComponents/Providers/Translations/TranslationsHook';
import { StyledCartItemAlert, StyledCartItemAlertDetails } from '../CartItemStyles';

interface ICartItemAlert {
    cartItem: ICartItemEntity;
    isCartDiscounted: boolean;
    showHazmat: boolean;
}

const cartItemName = 'cart-item';
const cartItemAlertClass = classes(`${cartItemName}-alert`);
const cartItemAlertIconClass = classes(`${cartItemName}-alert-icon`);
const cartItemAlertMessageClass = classes(`${cartItemName}-alert-message`);
const cartItemErrorAlertClass = `${cartItemAlertClass} item-error-alert`;
const translations = ['excludedFromDiscounts', 'itemIsTempOutOfStock', 'shippingRestrictionHazmat'];

const CartItemAlerts = observer(({ cartItem, isCartDiscounted, showHazmat }: ICartItemAlert) => {
    const { excludedFromDiscounts, itemIsTempOutOfStock, shippingRestrictionHazmat } =
        useTranslation(translations);
    const {
        discountPercent,
        isOutOfStock,
        product: { isHazmat, isPricedSample },
        discountableSku
    } = cartItem;
    const itemExludedFromDiscount = !discountPercent && isCartDiscounted;
    const sampleItemExludedFromDiscount =
        (isPricedSample || !discountableSku) && itemExludedFromDiscount;
    const itemAlerts = [
        {
            condition: !!sampleItemExludedFromDiscount,
            alertWrapperClass: cartItemAlertClass,
            alertText: excludedFromDiscounts
        },
        {
            condition: !!isOutOfStock,
            alertWrapperClass: cartItemErrorAlertClass,
            alertText: itemIsTempOutOfStock
        },
        {
            condition: !!isHazmat && showHazmat,
            alertWrapperClass: cartItemErrorAlertClass,
            alertText: shippingRestrictionHazmat
        }
    ];

    return (
        <>
            {itemAlerts.map(
                ({ condition, alertWrapperClass, alertText }) =>
                    condition && (
                        <StyledCartItemAlert
                            className={alertWrapperClass}
                            role="alert"
                            aria-live="assertive"
                        >
                            <StyledCartItemAlertDetails className={cartItemAlertIconClass} />
                            <StyledCartItemAlertDetails className={cartItemAlertMessageClass}>
                                {alertText}
                            </StyledCartItemAlertDetails>
                        </StyledCartItemAlert>
                    )
            )}
        </>
    );
});

export default CartItemAlerts;
